import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiFeedbackMessageComponent } from './eui-feedback-message.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiFeedbackMessageComponent,
    ],
    exports: [
        EuiFeedbackMessageComponent,
    ],
})
export class EuiFeedbackMessageModule { }
